<style>
  ::-webkit-scrollbar {
      display: none;
  }
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
  .page-enter-active, .page-leave-active {
    transition: opacity 0.2s, 
  }
  .page-enter, .page-leave-to {
    opacity: 0;
  }

  svg#clouds {
    position: fixed;
    bottom: -160px;
    left: 0;
    z-index: 0;
    width: 1920px;
    
    
  }

</style>

<template>
  <v-app id="app" class="app" style="background-color:#FAFAFA;">
  
    <!-- <svg 
      id="clouds" alt="Gray Clouds Background" xmlns="http://www.w3.org/2000/svg" width="2611.084" height="485.677" viewBox="0 0 2611.084 485.677">
      <path 
        id="Path_39" 
        fill="#E3F2FD" 
        data-name="Path 39" 
        stroke="#39a9dc" stroke-width="2" stroke-dasharray="5"
        d="M2379.709,863.793c10-93-77-171-168-149-52-114-225-105-264,15-75,3-140,59-152,133-30,2.83-66.725,9.829-93.5,26.25-26.771-16.421-63.5-23.42-93.5-26.25-12-74-77-130-152-133-39-120-212-129-264-15-54.084-13.075-106.753,9.173-138.488,48.9-31.734-39.726-84.4-61.974-138.487-48.9-52-114-225-105-264,15a162.027,162.027,0,0,0-103.147,43.044c-30.633-45.365-87.1-72.091-145.206-58.044-52-114-225-105-264,15-75,3-140,59-152,133-53,5-127,23-130,83-2,42,35,72,70,86,49,20,106,18,157,5a165.625,165.625,0,0,0,120,0c47,94,178,113,251,33,61.112,8.015,113.854-5.72,150.492-29.764a165.62,165.62,0,0,0,110.861-3.236c47,94,178,113,251,33,31.385,4.116,60.563,2.495,86.487-3.311,25.924,5.806,55.1,7.427,86.488,3.311,73,80,204,61,251-33a165.625,165.625,0,0,0,120,0c51,13,108,15,157-5a147.188,147.188,0,0,0,33.5-18.694,147.217,147.217,0,0,0,33.5,18.694c49,20,106,18,157,5a165.625,165.625,0,0,0,120,0c47,94,178,113,251,33C2446.709,1093.793,2554.709,922.793,2379.709,863.793Z" transform="translate(142.69 -634.312)" />
    </svg> -->
  
    <appsidebar 
      :title="title"
      v-model="selectedView"
      :items="(isLoggedIn==true)?appMetadata.appNavigation.navigationBar.logged.content:appMetadata.appNavigation.navigationBar.unlogged.content"
      :fixedactions="fixedactions"
      :detailed="(isLoggedIn==true)"
      v-on:action="handleAction($event)"
      v-on:fixedaction="$event.handler()"
      :hide="appSideBarHidden"
      :user="groupName"
    >
    </appsidebar>

    <v-content >
      <v-container fluid fill-height >
        <v-layout>
          <transition name="page" mode="out-in">
            <router-view v-on:action="handleAction($event)" :backimage="backgroundImage"/> 
          </transition>
        </v-layout>
      </v-container>
    </v-content>
      
    <v-snackbar
      v-model="showInfoPanel"
      :multi-line="true"
      :bottom="true"
      :right="true"
      :color="colorInfoPanel"
    >
      <span style="font-weight:bold">{{ textInfoPanel }} </span>
      <v-btn
        color="White"
        flat
        @click="showInfoPanel = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  
    
    <terminal style="height:50%;overflow-y:scroll;width:100%;text-align:left;z-index:10;position:absolute;bottom:2.5rem;padding-top:0.5rem" v-show="showTerminal"></terminal>
    <v-footer style="z-index:1" color="#FFD300" >
      <div style="text-align:center;width:100%">STMicroelectronics &copy; {{ new Date().getFullYear() }}</div>
    </v-footer>
  </v-app>
</template>

<script>
const background_image = require('@/assets/home/container.png')
import { mapGetters, mapState } from 'vuex'
import Terminal from './components/Terminal'
export default {
  name: 'app',

  components:{
    Terminal
  },

  data(){
    return{
      textInfoPanel : "",
      fixedactions: [],
      showInfoPanel : null,
      colorInfoPanel:"",
      backgroundImage : background_image,
      title:{
        title: (this.isLoggedIn==true)?this.groupName:'Asset-tracking',
        img: require('@/assets/st-logo.svg')
      },
      selectedView: null,
      appSideBarHidden: false,
      showTerminal: false
    }
  },

  computed: {
    ...mapGetters(
      {
        isLoggedIn: 'authentication/isLoggedIn',
        operationInProcess:"getOperationInfoInProcess",
        operationInProcessMessage:"getOperationInfoInProcessMessage",
        groupName: 'authentication/getUserName',
      }
    ),
    ...mapState({
      appMetadata: state => state.metadata,
      lastOperationSuccess: state => state.lastOperationSuccess,
      lastOperationMessage: state => state.lastOperationMessage,
      devices: state => state.devices.devices
    })
  },

  watch:{
    selectedView: function(newValue){
        if(newValue.effect)
          this
          .$store
          .dispatch(newValue.effect)
          .then(()=>{})
        else
          this.$store.commit('browseApp',{name:newValue.routeName})
    },
    isLoggedIn: async function(value) {
      
      if(value==false){
        this.selectedView = this.appMetadata.appNavigation.navigationBar.unlogged.default
        this.$store.commit('browseApp',{name:this.appMetadata.appNavigation.navigationBar.unlogged.default.routeName})
        this.$store.dispatch("destroyUserContext")
        this.appSideBarHidden = true
      }else{
        this.selectedView = this.appMetadata.appNavigation.navigationBar.logged.default
        this.$store.commit('browseApp',{name:this.appMetadata.appNavigation.navigationBar.logged.default.routeName})
        
        try {
          await this.$store.dispatch("initUserContext")
          await this.$store.dispatch("devices/fetchDevices")
          //  .then(
          //    async ()=>{
            
                if(this.appMetadata.models.views.settings.apiKeys)
                  await this.$store.dispatch("apiKeys/fetchApiKeys")

                if(this.appMetadata.models.views.settings.deviceProfiles)
                  await this.$store.dispatch("deviceProfiles/fetchDeviceProfiles")

                if(this.appMetadata.models.views.settings.dataConverters)
                  await this.$store.dispatch("deviceProfiles/fetchDataConverters")

                await this.$store.dispatch("devices/fetchPerimeters", this.devices)
        //      }
        //    )
        //    .catch((e)=>console.log(e))
        } catch (error) {
          console.log(error)
        }




        this.appSideBarHidden = false
      }
    },
    lastOperationSuccess:function(value){
      this.textInfoPanel = this.lastOperationMessage,
      this.showInfoPanel = true,
      this.colorInfoPanel= (value==true)?"green":"red"
    }
  },

  async created(){
    try{
      await this.$store.dispatch('init')
    }catch(e){
      console.log(e)
      if(e.laChecked==false){
        // show LA form
        this.$store.commit('browseApp',{name:'licenseagreement'}) 
      }
    }

    let urlParams = new URLSearchParams(window.location.search) 
    let forceRelogin = localStorage.getItem('forceRelogin')
    if(forceRelogin || (urlParams.has("id_token") && urlParams.has("access_token"))){
          localStorage.removeItem('forceRelogin')
          await 
              this
              .$store
              .dispatch('authentication/login',"google")
    }

    //await this.$store.dispatch('authentication/login')
  },

  mounted(){
      if(this.isLoggedIn==false){
        this.selectedView = this.appMetadata.appNavigation.navigationBar.unlogged.default
        this.$store.commit('browseApp',{name:this.appMetadata.appNavigation.navigationBar.unlogged.default.routeName})
      }else{
        this.selectedView = this.appMetadata.appNavigation.navigationBar.logged.default
        this.$store.commit('browseApp',{name:this.appMetadata.appNavigation.navigationBar.logged.default.routeName})
      }
      this.fixedactions = [{id:'openterminal', icon:'code', handler: () => this.showTerminal = !this.showTerminal}];
  },

  methods:{
    handleAction(actionName){
        this.$store
          .dispatch(actionName)
          .then(()=>{})
    },

    browse(sidebarItem){
      if(sidebarItem.action)
        this[sidebarItem.action](sidebarItem)
      else
        this.$store.commit('browseApp',{name:sidebarItem.routeName}) 
    },
  }
}
</script>


